export const SCOPE_WARNING_MESSAGE =
  'The internal components of the InputCreditCard must be its own elements. For more information, see the documentation.'
